// Desktop hover open for Studio 14 (keeps mobile tap behavior)
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(hover:hover) and (min-width: 990px)');

  function applyHover() {
    document.querySelectorAll('header .header__inline-menu details').forEach((d) => {
      const panel = d.querySelector('.mega-menu, .mega-menu__content, .header__submenu');
      if (!panel) return;

      // clean 可能残留 open/hidden
      if (!mq.matches) { d.removeAttribute('open'); return; }

      // 悬停打开
      d.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        d.setAttribute('open', 'open');
        panel.classList.remove('hidden');
        panel.removeAttribute('hidden');
        panel.style.opacity = '1';
        panel.style.visibility = 'visible';
        panel.style.pointerEvents = 'auto';
        panel.style.zIndex = '70';
      });

      // 移出关闭
      d.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        d.removeAttribute('open');
        panel.classList.add('hidden');
        panel.setAttribute('hidden', 'hidden');
        panel.style.opacity = '';
        panel.style.visibility = '';
        panel.style.pointerEvents = '';
        panel.style.zIndex = '';
      });

      // 键盘可访问性
      d.addEventListener('focusin', () => {
        if (!mq.matches) return;
        d.setAttribute('open', 'open');
        panel.classList.remove('hidden');
        panel.removeAttribute('hidden');
      });
      d.addEventListener('focusout', (e) => {
        if (!mq.matches) return;
        if (!d.contains(e.relatedTarget)) {
          d.removeAttribute('open');
          panel.classList.add('hidden');
          panel.setAttribute('hidden', 'hidden');
        }
      });
    });
  }

  applyHover();
  // 视口切换时重置
  window.addEventListener('resize', () => { applyHover(); }, { passive: true });
});
